import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Manglende alternativ tekst til dette billede',
    noAnswers: 'Hvis du ikke har mulighed for at svare, skal du klikke på næste for at fortsætte.',
    placeholder: 'Angiv venligst ...',
    pleaseSelect: 'Vælg venligst ...',
    rotateLandscape: 'Slå venligst orienteringslåsen fra på din telefon, og rotér til landskab for at fortsætte.',
    rotatePortrait: 'Rotér din telefon fra landskab til portræt for at fortsætte.',
    ir: {
      selectWebCam: 'Vælg webcam (hvis det er tilgængeligt), eller klik på "Gennemse" for at uploade fra din enhed',
      noWebCam: 'Der er ikke registreret noget webcam',
      accessCamUpload: 'ADGANG TIL KAMERA/UPLOAD',
      browse: 'GENNEMSE',
      uploadPhoto: 'Upload et foto',
      instead: 'i stedet',
      startOver: 'Start forfra',
      capture: 'TAG BILLEDE',
      allDone: 'Alt er klaret!',
      somethingWrong: 'Beklager, der gik noget galt. Prøv venligst igen senere',
      couldntRead: 'Beklager, vi kunne ikke læse koden!',
      couldntProcess: 'Beklager, vi kunne ikke behandle dit billede!',
      moveOn: 'Prøv igen, eller indsend dit billede, og gå videre',
      tryAgain: 'Prøv venligst igen',
      dataReceived: 'Data modtaget!',
      enterManually: 'Prøv venligst igen eller indtast dataene manuelt nedenfor',
      positionQR:
        'Placer QR-koden foran dit kamera, så den passer ind i den røde ramme, eller upload den fra din computer.',
      submit: 'INDSEND',
      analyzing: 'Analyserer billede, vent venligst...',
      cantAnalyze:
        'Vær opmærksom - vi kunne ikke rendere dette billede. Prøv venligst at indsende igen eller vælg et mere generisk billedformat (JPG, PNG, GIF, BMP).',
      wrongFormat:
        'Vi beklager - vi understøtter ikke dette filformat. Upload venligst en understøttet billedtype (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Der er ikke registreret noget webcam',
      uploadVideo: 'Upload en video',
      skip: 'Spring over?',
      accessCamUpload: 'ADGANG TIL KAMERA/UPLOAD',
      browse: 'GENNEMSE',
      instead: 'i stedet',
      or: 'eller',
      stopRecording: 'Stop optagelse',
      willBeStopped: 'Optagelsen stopper efter 5 minutter',
      stopOnDone: 'Stop optagelsen, når du er færdig!',
      record: 'OPTAG',
      somethingWrong: 'Beklager, der gik noget galt. Prøv venligst igen senere',
      microphone: 'Mikrofon',
      camera: 'Webkamera',
      selectMicrophone: 'Vælg din mikrofon',
      selectCam: 'Vælg dit webkamera',
      upload: 'Upload',
      playback: 'Afspilning',
      stopPlayback: 'Stop optagelse',
      submit: 'INDSEND',
      startOver: 'Start forfra',
      allDone: 'Alt er klaret!',
      alternativeRecordSpan:
        'Du bedes uploade et videoklip fra din computer-enhed. Alternativt kan du optage videoen med et webcam.',
      alrenativeRecordHref: ' optag videoen med et webcam.',
      cantAnalyze:
        'Vær opmærksom - vi kunne ikke rendere denne video. Prøv venligst at indsende igen eller vælg et mere generisk videoformat (MP4, M4V, WEBPM)',
      wrongFormat:
        'Vi beklager - vi understøtter ikke dette filformat. Upload venligst en understøttet videotype (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'VÆLG',
      pleaseChoose: 'Vælg venligst',
      this: 'DETTE',
      one: 'en',
      myChoice: 'Mit VALG'
    },
    hm: {
      addComment: 'Tilføj venligst en kommentar nedenfor',
      commentMandatoryPlaceHolder: 'Tilføj venligst obligatorisk kommentar...',
      commentOptionalPlaceHolder: 'Tilføj venligst valgfri kommentar... ',
      dragPin: 'Træk for at flytte positionen (klik/tap længe for præcis fastgørelse).',
      removePin: 'Træk uden for billedet for at slette det.',
      editComment: 'Klik/tryk på markeringen for at redigere kommentaren.',
      addPin: 'Træk markeringer fra panelet nedenfor, og placer den på et sted på billedet, som du selv vælger.',
      addPins: 'Træk markeringer fra panelet nedenfor, og placer dem på et sted på billedet, som du selv vælger.',
      leavePins: (minPoints, maxPoints) =>
        `Efterlad mindst ${minPoints} men ikke mere end ${maxPoints} markeringer af hver slags.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Efterlad mindst ${minPoints}, men ikke mere end ${maxPoints} markeringer af enhver art.`,
      leavePinsPerPage: (minPoints, maxPoints) => `Efterlad mindst ${minPoints} og højst ${maxPoints} markeringer.`,
      leavePinsWithOff: maxPoints =>
        `Efterlad højst ${maxPoints} markeringer af hver slags, eller klik på Næste for at springe over.`,
      leavePinsWithOffAny: maxPoints =>
        `Efterlad højst ${maxPoints} markeringer af enhver art, eller klik på Næste for at springe over for at springe over.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Efterlad højst ${maxPoints} markeringer, eller klik på Næste for at springe over.`,
      leavePinWithOff: 'Efterlad højst 1 markering af enhver art, eller klik på Næste for at springe over.',
      leavePinWithOffAny: 'Efterlad højst 1 markering af enhver art, eller klik på Næste for at springe over.',
      leavePinPerPageWithOff: 'Efterlad højst 1 markering af enhver art, eller klik på Næste for at springe over.',
      leaveExactlyPin: 'Efterlad venligst 1 markering af hver slags.',
      leaveExactlyPinAny: 'Efterlad venligst 1 markering af enhver art.',
      leaveExactlyPinPerPage: 'Efterlad venligst 1 markering.',
      leaveExactlyPins: maxPoints => `Efterlad venligst ${maxPoints} markeringer af enhver art.`,
      leaveExactlyPinsAny: maxPoints => `Efterlad venligst ${maxPoints} markeringer af enhver art.`,
      leaveExactlyPinsPerPage: maxPoints => `Efterlad venligst ${maxPoints} markeringer.`,
      leaveComment: 'Skriv under billedet for at efterlade en kommentar.',
      noAnswers: '',
      outOfPins: 'Du er løbet tør for markeringer',
      pinsBehavior:
        'Når du bevæger dig hen over billedet, vil du se områder, som vil blive fremhævet med et enkelt markeringspunkt.',
      clusters: 'Du kan kun placere markeringer i disse markerede områder.',
      contentAware: 'Du kan placere markeringer inden for eller uden for de markerede områder.'
    },
    mp: {
      expand_note: 'Hold musen hen over eller klik på billedet for at forstørre',
      rb_note: rows => `Vælg kun 1 svar pr. punkt ${rows ? ' nedenfor' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Vælg ${min !== 1 ? '' : 'kun'} ${min} svar pr. punkt ${rows ? ' nedenfor' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Vælg mindst ${min} svar , men ikke mere end ${max} pr. punkt${rows ? ' nedenfor' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Vælg venligst mindst ${min} svar 1 svar pr. punkt${rows ? ' nedenfor' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Vælg venligst ikke mere end ${max} svar pr. punkt${rows ? ' nedenfor' : ''}:`
        } else {
          return 'Sæt kryds i alt, hvad der er relevant:'
        }
      }
    },
    sh: {
      note: 'Klik på et produkt for at zoome ind og lægge det i din virtuelle indkøbskurv, hvis du ønsker at købe det i butikken',
      amazonNote: 'Klik på et produkt for at zoome ind og lægge det i din virtuelle indkøbskurv.',
      fullCart: 'Din indkøbskurv er fuld!',
      qty: 'ANTAL',
      each: 'hver',
      items: 'genstande',
      addToCart: 'LÆG I KURVEN',
      deleteFromCart: 'SLET',
      next: 'NÆSTE',
      emptyCard: 'Din indkøbskurv er tom',
      total: 'Indkøbskurv',
      clearCart: 'Ryd indkøbskurv',
      backToStore: 'Tilbage til butik',
      scrollError: `Scroll helt ud til venstre og helt ud højre for at fortsætte i undersøgelsen. `,
      na: 'Ingen af ovennævnte'
    },
    rb: {
      note: 'Vælg venligst kun 1 vare:'
    },
    vo: {
      note: 'Se venligst videoen til slut'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Vælg venligst alle relevante:'
        } else if (min === max) {
          return `Vælg venligst ${min !== 1 ? 'any' : 'kun'} ${min} item${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Vælg venligst mindst ${min} item${min !== 1 ? 's' : ''} men ikke mere end ${max}:`
        } else if (5000 === max && min > 0) {
          return `Vælg venligst mindst ${min} item${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Vælg ikke mere end ${max} item${max !== 1 ? 's' : ''}:`
        } else {
          return 'Vælg venligst alle relevante:'
        }
      }
    },
    oe: {
      na: 'Ikke anvendelig',
      note: (min, max, optional) => {
        if (min === max) {
          return `Skriv venligst ${1 !== min ? 'any' : 'præcis'} ${min} tegn${1 !== min ? 's' : ''}${
            optional ? ' (valgfri)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Skriv venligst mindst ${min} tegn${1 !== min ? 's' : ''} men ikke mere end ${max}${
            optional ? ' (valgfri)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Skriv venligst mindst ${min} tegn${1 !== min ? 's' : ''}${optional ? ' (valgfrit)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Indtast ikke mere end ${max} tegn${1 !== min ? 's' : ''}${optional ? ' (valgfrit)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Udfyld venligst følgende felter:'
    },
    mx: {
      note: 'Flyt de markerede skydere for at fortsætte',
      dragSlider: 'Træk til venstre eller højre for at svare'
    },
    psc: {
      dragLeftRight: 'Træk til venstre eller højre for at svare'
    },
    ps: {
      note: (value, remaining) =>
        `Venligst fordel ${remaining ? 'resterende' : ''} ${value} mellem nedenstående elementer`,
      allDone: `Alt er klaret`,
      total: `Всего:`,
      dragSlider: 'Arrastre hacia la izquierda o la derecha para responder'
    },
    cx: {
      note: 'Åbn dropbox og begynd at skrive dit svar for at autoscrolle eller vælg det manuelt'
    },
    ro: {
      note: 'Træk op eller ned for at ændre rækkefølgen:'
    },
    md: {
      note1: 'Klik/tryk venligst på det emne, du vælger først.<br/>Klik/tryk igen for at fjerne valget.',
      note2: 'Klik/tryk venligst nu på det emne, du sidst har valgt.<br/>Klik/tryk igen for at fjerne valget.',
      note3: 'Tak! Fortsæt til næste spørgsmål, eller klik/tryk på et element, der ikke er valgt, for at starte forfra.'
    },
    aro: {
      note: 'Vælg venligst et element fra hvert par.'
    },
    wd: {
      note: 'Sørg for, at hver efterfølgende værdi er større end den foregående.'
    },
    emd: {
      note: 'Se venligst videoen til slut',
      noAnswers: 'Hvis du ikke har mulighed for at svare, skal du klikke på næste for at fortsætte.',
      start: 'Klik og hold nede for at starte',
      resume: 'Klik og hold nede for at genoptage',
      continue: 'Du er klar!<br /> Klik på Næste for at fortsætte',
      continueMobile: 'Du er klar!<br />Klik HER for at fortsætte',
      training: {
        session: 'Træningssession',
        note: 'Afslut venligst træningen',
        moveLeft: 'Træk drejeskiven helt til venstre',
        moveBottom: 'Træk drejeskiven helt ned til bunden',
        moveRight: 'Træk nu drejeskiven helt til højre',
        moveTop: 'Træk nu drejeskiven helt op til toppen',
        success: 'Godt arbejde!'
      }
    },
    sft: {
      noAnswers: 'Hvis du ikke har mulighed for at svare, skal du klikke på næste for at fortsætte.',
      note: 'Svar venligst så hurtigt som muligt med det svar, der intuitivt føles rigtigt',
      finish: 'Du er klar!<br />Klik HER for at fortsætte',
      training: {
        start:
          '<p>Dette spørgsmål vil hurtigt vise dig forskellige ord og vil kræve din koncentration.' +
          'Du skal reagere hurtigt for at besvare.</p> <p>Er du klar til at øve dig?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tryk på "{buttonLeft}"`
            : (mouse ? `Klik "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Hit "{keyBtnLeft}" nøgle` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tryk på "{buttonRight}"`
            : (mouse ? `Klik "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Hit "{keyBtnRight}" nøgle` : ''),
        fail: () => 'For langsom',
        success: () => 'Fantastisk!',
        finish: () =>
          '<p><strong>Fremragende!</strong></p><p>Sørg for, at du ikke vil blive distraheret i de næste 2-3 minutter</p><p>Klik på Næste for at starte, når du er klar</p>'
      },
      buttons: {
        start: 'Start',
        yesno: {
          left: 'Ja',
          right: 'Nej'
        },
        matches: {
          left: 'Match',
          right: 'Ikke et match'
        },
        fits: {
          left: 'Passer',
          right: 'Passer ikke'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
